import {webClient} from "../../config/axios";
import {handleError} from "../handleRequestError";

export const downloadConfigRequest = (callback) => {
    webClient.get('/download')
        .then(response => {
            callback(response.data, false);
        })
        .catch(err => {
            handleError(err, callback);
        })
};